/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";
import { buildUrl } from "../../utils/bindUrl";
import {
  IOutsourced,
  IResponseListOutsourcedes,
  IResponseShowOutsourced,
} from "../../interfaces/outsourcedes";

const BASE = "/outsourcedes";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listOutsourcedes({
  filter,
  includes,
  page,
  limit,
  select,
  sort,
}: IListParams) {
  const { data } = await api.get<IResponseListOutsourcedes>(BASE, {
    params: { filter, includes, page, limit, select, sort },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showOutsourced({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowOutsourced>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createOutsourced({
  outsourced,
}: {
  outsourced: IOutsourced;
}) {
  const { data } = await api.post<IResponseShowOutsourced>(BASE, { outsourced });
  return data;
}

export async function updateOutsourced({
  id,
  outsourced,
}: {
  id: string | number;
  outsourced: IOutsourced;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowOutsourced>(url, { outsourced });
  return data;
}

export async function deleteOutsourced({ id }: { id: string | number }) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  // validateStatus => true evita cair no interceptor de erro (toast automático)
  const resp = await api.delete(url, { validateStatus: () => true });
  return { status: resp.status, data: resp.data };
}

export async function reactivateOutsourced({ id }: { id: string | number }) {
  const url = buildUrl(`${BASE}/{id}/reactivate`, { id });
  const { data } = await api.post<IResponseShowOutsourced>(url);
  return data;
}

// DASHBOARD
export async function getRegistrationHistory(year: number) {
  const { data } = await api.get<Array<{ label: string; value: number }>>(`${BASE}/dashboard/registration-history`, {
    params: { year }
  });
  return data;
}

export async function getAptitudeStats() {
  const { data } = await api.get<{ total: number; apt: number }>(`${BASE}/dashboard/aptitude-stats`);
  return data;
}

export async function getRegistrationTotal(year: number) {
  const { data } = await api.get<{ total: number }>(`${BASE}/dashboard/registration-total`, {
    params: { year }
  });
  return data;
}
